import React from "react";
import UnderReview from "./UnderReview";

export default function Rejected() {
  return <UnderReview isRejected={true} />;
}
